import InfectedFile from "./views/InfectedFile";

const routes = [
  {
    path: "/infected-file",
    name: "infected-file",
    component: InfectedFile
  }
];

export default routes;
